import { PropsWithChildren } from 'react';

import { css } from '@compiled/react';

import { token } from '@atlaskit/tokens';

import { wacToken } from '@/libraries/design/foundations';
import { useTheme } from '@/libraries/design/utils/dark-theme-provider';

export const LinkColumn = ({ children }: PropsWithChildren) => {
	const { isDarkTheme } = useTheme();
	return (
		<div
			role="none"
			css={[
				css({
					display: 'flex',
					flexDirection: 'column',
				}),
				navColumnHeaderStyles,
				isDarkTheme && navColumnHeaderDarkThemeStyles,
			]}
		>
			{children}
		</div>
	);
};

const navColumnHeaderStyles = css({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	'h2.nav-column-header': {
		padding: 0,
		marginBlockStart: 0,
		marginBlockEnd: token('space.200'),
		marginInline: 0,
		textTransform: 'uppercase',
		color: wacToken('color.primary.black'),
		fontSize: '0.75rem',
		fontFamily: wacToken('font.charlie.text'),
		fontWeight: 700,
		lineHeight: '1rem',
	},
});

const navColumnHeaderDarkThemeStyles = css({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	'h2.nav-column-header': {
		color: wacToken('color.neutral.light0'),
	},
});
